import {FC} from 'react'
import {Link} from 'react-router-dom'
import {text} from 'shared/mirrors/text'
import {HorizontalDivider} from 'shared/ui/dividers'
import {Facebook, Instagram, Logo, MasterCardCheck, VisaCard, VisaSecureBlur} from 'shared/ui/icons'
import styles from './styles.module.scss'

export const FooterSection: FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.columnsWrapper}>
          <div className={styles.contacts}>
            <div className={styles.contactWrapper}>
              <div className={styles.logoContainer}>
                <div className={styles.icon}><Logo /></div>
                <p className={styles.logoTitle}>{text.main.siteName}</p>
              </div>
              <p className={styles.info}>GoChatty – space for exclusive relationships</p>
              {/* <Link to='mailto:contact@gochatty.com' className={styles.email}>contact@gochatty.com</Link>*/}
            </div>
            <div className={styles.socialContainer}>
              <div className={styles.icon}><Facebook /></div>
              <div className={styles.icon}><Instagram /></div>
            </div>
          </div>
          {/* <ColumnComponent
            title='Legal terms'
            links={[{name: 'Privacy Policy'}, {name: 'GDPR'}, {name: 'Disclosures & Disclaimers'}]}
          /> */}
          <ColumnComponent
            title='Legal terms'
            links={[
              {name: 'Privacy Policy', link: '/privacy-policy'},
              {name: 'Terms of Use', link: '/terms-of-use'},
              {name: 'Dating Safety & Anti-Scam Policy', link: '/dating-safety'},
              {name: 'Anti Trafficking Policy', link: '/anti-trafficking-policy'}
            ]}
          />
          <ColumnComponent
            title='Useful links'
            links={[
              {name: 'Community Rules', link: '/community-rules'},
              {name: 'Credentials Storage Agreement', link: '/credentials-storage-agreement'}
            ]}
          />
          <ColumnComponent
            title='Contact'
            links={[
              {name: 'support@gochatty.com', isMail: true},
            ]}
          />
        </div>
        <div className={styles.footer}>
          <HorizontalDivider className={styles.divider} />
          <div className={styles.copyrightContainer}>
            <div className={styles.operatedByContainer}>
              <span className={styles.copyright}>© {text.main.siteName} 2023. All rights reserved</span>
              <span className={styles.operatedBy}>
                Estonia: {text.main.estoniaAddress} <br />
                UK: {text.main.ukAddress} <br />
                Gibraltar: {text.main.gibraltarAddress} <br />
              </span>
            </div>

            <div className={styles.creditContainer}>
              <MasterCardCheck />
              <VisaSecureBlur />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

type ColumnComponentProps = {
  title: string,
  links: {name: string, link?: string, onClick?: VoidFunction, isMail?: boolean}[]
}

const ColumnComponent: FC<ColumnComponentProps> = ({title, links}) => {
  return (
    <div className={styles.columnWrapper}>
      <p className={styles.columnTitle}>{title}</p>
      <div className={styles.linksContainer}>
        {links.map(({name, link, onClick, isMail}) =>
          onClick ?
            <div key={name} className={styles.link} onClick={onClick}>
              {name}
            </div>
            :
            <Link key={name} className={styles.link} to={isMail ? `mailto:${name}` : link || '/'}>
              {name}
            </Link>
        )}
      </div>
    </div>
  )
}